var _dec, _class, _descriptor, _dec2, _dec3, _dec4, _dec5, _class2, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _class3, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveTrait from "../../lib/Traits/Decorators/primitiveTrait";
import objectTrait from "../../lib/Traits/Decorators/objectTrait";
import objectArrayTrait from "../../lib/Traits/Decorators/objectArrayTrait";
import ModelTraits from "../../lib/Traits/ModelTraits";
export let TraitsWithRemoval = (_dec = primitiveTrait({
  name: "someValue",
  description: "Description",
  type: "string",
  isNullable: true
}), _class = class TraitsWithRemoval extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "someValue", _descriptor, this);
  }
  static isRemoval(model) {
    return model.someValue === null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "someValue", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "praise the model layer";
  }
}), _class);
export let NestedTraits = (_dec2 = primitiveTrait({
  name: "WithDefault",
  description: "Description",
  type: "number"
}), _dec3 = primitiveTrait({
  name: "WithoutDefault",
  description: "Description",
  type: "number"
}), _dec4 = primitiveTrait({
  name: "another",
  description: "another",
  type: "string"
}), _dec5 = primitiveTrait({
  name: "another with default",
  description: "another with default",
  type: "string"
}), _class2 = class NestedTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "withDefault", _descriptor2, this);
    _initializerDefineProperty(this, "withoutDefault", _descriptor3, this);
    _initializerDefineProperty(this, "another", _descriptor4, this);
    _initializerDefineProperty(this, "anotherWithDefault", _descriptor5, this);
    // TODO: Add trait decorator for unknown object
    _defineProperty(this, "unknownObject", void 0);
    _defineProperty(this, "unknownObjectWithDefault", {});
    // TODO: Add/extend trait for nullable primitive
    _defineProperty(this, "withNull", void 0);
  }
}, _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "withDefault", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 10;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "withoutDefault", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "another", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "anotherWithDefault", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "default";
  }
}), _class2);
let TraitsForTesting = (_dec6 = primitiveTrait({
  name: "WithDefault",
  description: "Description",
  type: "number"
}), _dec7 = primitiveTrait({
  name: "WithoutDefault",
  description: "Description",
  type: "number"
}), _dec8 = primitiveTrait({
  name: "SomeBool",
  description: "Description",
  type: "boolean"
}), _dec9 = objectTrait({
  name: "NestedWithDefault",
  description: "Description",
  type: NestedTraits
}), _dec0 = objectTrait({
  name: "NestedWithDefault",
  description: "Description",
  type: NestedTraits
}), _dec1 = objectArrayTrait({
  name: "NestedArrayWithDefault",
  description: "Description",
  type: NestedTraits,
  idProperty: "withDefault"
}), _dec10 = objectArrayTrait({
  name: "NestedArrayWithoutDefault",
  description: "Description",
  type: NestedTraits,
  idProperty: "withDefault"
}), _dec11 = objectArrayTrait({
  name: "NestedArrayWithoutIdProperty",
  description: "Description",
  type: TraitsWithRemoval,
  idProperty: "index"
}), _class3 = class TraitsForTesting extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "withDefault", _descriptor6, this);
    _initializerDefineProperty(this, "withoutDefault", _descriptor7, this);
    _initializerDefineProperty(this, "someBool", _descriptor8, this);
    _initializerDefineProperty(this, "nestedWithDefault", _descriptor9, this);
    _initializerDefineProperty(this, "nestedWithoutDefault", _descriptor0, this);
    _initializerDefineProperty(this, "nestedArrayWithDefault", _descriptor1, this);
    _initializerDefineProperty(this, "nestedArrayWithoutDefault", _descriptor10, this);
    _initializerDefineProperty(this, "nestedArrayWithoutIdProperty", _descriptor11, this);
    // TODO: Add trait decorator for unknown object
    _defineProperty(this, "unknownObject", void 0);
    _defineProperty(this, "unknownObjectWithDefault", {});
    // TODO: Add/extend trait for nullable primitive
    _defineProperty(this, "withNull", void 0);
  }
}, _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "withDefault", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 10;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "withoutDefault", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, "someBool", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "nestedWithDefault", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new NestedTraits();
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class3.prototype, "nestedWithoutDefault", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class3.prototype, "nestedArrayWithDefault", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, "nestedArrayWithoutDefault", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, "nestedArrayWithoutIdProperty", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
export { TraitsForTesting as default };